import React, { Component } from 'react';
import ServerSideGrid from '../common/custom-controls/ServerSideGrid';
import { subscriberService } from '../../services/subscriber-service';
import { GRID_LIMIT } from '../../utils/configs';
import Loader from '../common/custom-controls/Loader';

class NicSummary extends Component {
    GRID_CONFIG = {
        columns: [
            // {
            //     id: 1,
            //     name: 'id',
            //     headerTitle: 'ID',
            //     canSort: true,
            //     width: '25%'
            // },
            {
                id: 2,
                name: 'mobile',
                headerTitle: 'Mobile',
                canSort: true,
                width: '25%'
            },
            {
                id: 3,
                name: 'NIC',
                headerTitle: 'Nic',
                canSort: true,
                width: '25%'
            },
            {
                id: 4,
                name: 'source',
                headerTitle: 'Channel',
                canSort: true,
                width: '25%'
            },
            
        ],
        gridData: [],
        meta: {
            pageSize: parseInt(GRID_LIMIT),
            showLoadingSpinner: true,
            totalItems: 0,
            selectedPage: 1,
            orderBy: 'id',
            sortBy: 'desc'
        }
    }

    INITIAL_STATE = {
        gridConfig: this.GRID_CONFIG,
        toast: {
            type: '',
            message: ''
        },
        gridData: [],
        serverSideData: '',
        filterData: {
            nic: ''
        },
        showLoadingSpinner: false,
        reloader: false,
    }

    constructor(props) {
        super(props);
        this.state = {
            ...this.INITIAL_STATE,
            userData: props.userData
        }
    }


    //The grid response handled here
    handleResponce = (params) => {

        let { gridConfig } = this.state;

        gridConfig.meta.selectedPage = params.selectedPage;
        if (params.sortBy) {
            gridConfig.meta.orderBy = params.sortBy;
        }

        if (params.sortOrder) {
            gridConfig.meta.sortBy = params.sortOrder;
        }

        this.setState({ serverSideData: params, gridConfig, showLoadingSpinner: true });
        this.updateGridState();
    }


    renderGrid = () => {
        const { gridConfig } = this.state;
        if (gridConfig.gridData) {
            return (
                <ServerSideGrid gridConfig={gridConfig}
                    actionHandler={this.handleActionClick}
                    handleOrder={this.handleResponce}
                    handlePage={this.handleResponce}
                    toggleModal={'collapse'} />
            )
        }
    }

    updateGridState = () => {
        let { gridConfig, gridData, filterData, userData } = this.state;
        let toast = {}
        filterData.nic = userData.nicNumber;

        //To get data from server-side pagination need to pass pageSize, selectedPage, orderBy, sortBy
        subscriberService.getNicSummary(gridConfig.meta, filterData).then((results) => {
            if (results.statusCode === 200) {
                gridConfig.gridData = results.data.data;
                gridConfig.meta.totalItems = results.data.page.total;
                gridConfig.meta.showLoadingSpinner = false;
                gridData = results.data.data;
                this.setState({ gridConfig, gridData, showLoadingSpinner: false });
                this.props.onSearch(toast);
            } else {
                gridConfig.meta.showLoadingSpinner = false;
                toast = {
                    type: 'warning',
                    message: results.data.description
                }
                this.props.onSearch(toast);
                this.setState({ gridConfig })
            }
        }).catch((error) => {
            gridConfig.meta.showLoadingSpinner = false;
            toast = {
                type: 'warning',
                message: error.message
            }
            this.setState({
                gridConfig
            })
        });
    }

    componentDidMount = () => {
        this.updateGridState();
    }


    render() {
        const {reloader } = this.state;

        return (
            <div>
                {this.state.showLoadingSpinner ?
                    <Loader /> : ''}
                {reloader ? '' : this.renderGrid()}
            </div>

        )
    }
}

export default NicSummary;
